// gatsby-plugin-offline's service worker can silently swap a reload for a
// generic cached "app shell" once it thinks it has everything needed for
// the current page offline. That shell is a bare skeleton (no page-specific
// content, e.g. our Pagefind search widget) that Gatsby's client router is
// supposed to re-render on top of — but it doesn't restore inline <script>
// tags like the one that loads Pagefind's UI, so the search box silently
// disappears on reload. `offlineShellEnabled` is in-memory in the service
// worker and resets whenever the browser recycles an idle worker, so this
// has to run on every client entry, not just once.
export const onClientEntry = () => {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  const disableOfflineShell = () => {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        gatsbyApi: "disableOfflineShell",
      });
    }
  };

  disableOfflineShell();
  navigator.serviceWorker.addEventListener(
    "controllerchange",
    disableOfflineShell,
  );
};

// gatsby-plugin-offline's own onRouteUpdate hook unconditionally re-sends
// "enableOfflineShell" on every client-side navigation, undoing the above.
// Re-disable it after each route change too. The delay lets that hook's
// synchronous postMessage land first regardless of hook registration order.
export const onRouteUpdate = () => {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  setTimeout(() => {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        gatsbyApi: "disableOfflineShell",
      });
    }
  }, 0);
};
